import React from "react"
import { path } from "ramda"
import { useSelector, useDispatch } from "react-redux"
import { ShowPackageDetailsModal, PackageDetails, Query, SelectedCountry } from "../../utils/selector"
import { actionTypes, makeAction } from "../../states/actions"
import PopupModalBase from "./popup-modal-base"
import PackageDetailsComponent from "../package-details"
import { Container } from "./package-details-modal.styles"

const PackageDetailsModal = ({ id }) => {
  const { currency: currencyFromQuery } = useSelector(Query)
  const show = useSelector(ShowPackageDetailsModal)
  const userSelectedCountry = useSelector(SelectedCountry)
  const packageDetails = useSelector(PackageDetails)
  const dispatch = useDispatch()

  const packageDetailProps = {
    ...packageDetails,
    currency: path(["currency"], packageDetails) || currencyFromQuery,
    userSelectedCountry
  }

  return (
    <PopupModalBase id={id} expand={true} show={show} onCloseClick={() => dispatch(makeAction(actionTypes.APP_SET_PACKAGE_DETAILS_MODAL_SHOW, { showPackageDetailsModal: false }))}>
      <Container>
        <PackageDetailsComponent {...packageDetailProps} />
      </Container>
    </PopupModalBase>
  )
}

export default PackageDetailsModal
